<template>
  <uiDashedBorder
    class="flex h-full w-full flex-col items-center justify-center p-4"
  >
    <uiTypography class="text-primary" variant="span">
      {{ $t("No destinations connected") }}
    </uiTypography>
    <uiTypography class="text-secondary" variant="span">
      {{ $t("Choose destinations on the left to start streaming") }}
    </uiTypography>
  </uiDashedBorder>
</template>

<script setup lang="ts"></script>
